import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { CallANPR } from '@classes/anpr/callANPR';
import { LicenseANPR } from '@classes/anpr/licenseANPR';
import { AddUser } from '@classes/user/userAdd';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { LicenseService } from '@services/anpr/license.service';
import { UserService } from '@services/user/user.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

const reader = new FileReader();

@Component({
  selector: 'app-anpr-home',
  templateUrl: './anpr-home.component.html',
  styleUrls: ['./anpr-home.component.scss'],
})
export class ANPRHomeComponent implements OnInit {
  faCamera = faCamera;
  user: AddUser;
  clientId: string = '';
  license: LicenseANPR;
  canUseAnpr: boolean;
  calls: CallANPR[] = [];
  isLoading = false;
  dateBefore2weeks: boolean;
  fileName = '';
  currentCall: CallANPR;
  selectedCall: CallANPR;
  answer: CallANPR;
  img: any;
  // imgDashboard: string;

  constructor(
    private userService: UserService,
    private licenseService: LicenseService,
    private _snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.img = null;
    this.answer = null;
    this.getCurrentLicense();
    this.userService.clientChangedSubject.subscribe(() => {
      this.updateCurrentLicense();
    });
  }

  afterAnswer(answer: CallANPR) {
    this.answer = answer;
    if (this.answer.userAnswer == false) {
      this.updateCurrentLicense(true);
    }
  }

  getCurrentLicense() {
    this.isLoading = true;
    setTimeout(() => {
      this.updateCurrentLicense();
    }, 1000); // SPARADRAP

    // this.userService.getCurrentUser().subscribe((res) => {
    //   this.user = res;
    //   this.clientId = this.user.client.id;
    //   this.licenseService.getClientLicense(this.clientId).subscribe((res) => {
    //     this.license = res;
    //     this.canUseAnpr = this.license && this.license.status.name == 'Active';
    //     this.getClientCalls();
    //   });
    // });
  }

  updateSelectedCall(call: CallANPR) {
    this.selectedCall = call;
    this.getImage();
  }

  updateCurrentLicense(justUpdateLicense = false) {
    this.clientId = this.userService.clientSelected;
    if (this.clientId) {
      this.licenseService.getClientLicense(this.clientId).subscribe((res) => {
        this.license = res;
        this.canUseAnpr = this.license && this.license.status.name == 'Active';
        if (!justUpdateLicense) {
          this.getClientCalls();
          this.before2weeks();
        }
      });
    }
  }

  getClientCalls() {
    this.licenseService.getClientCalls(this.clientId).subscribe((res) => {
      this.calls = res.reverse();
      this.isLoading = false;
    });
  }

  before2weeks() {
    let date2weeks = new Date();
    date2weeks.setDate(date2weeks.getDate() + 14);

    let date1 = new Date(date2weeks).getTime();
    let date2 = new Date(this.license.expiryDate).getTime();

    this.dateBefore2weeks = date2 <= date1;
  }

  onFileSelected(event) {
    const file: File = event.target.files[0];

    if (file) {
      this.openSnackBar('Picture sent to ANPR', 'OK');
      this.selectedCall = null;
      this.isLoading = true;
      this.fileName = file.name;
      this.licenseService.useAnpr(file).subscribe((res) => {
        this.currentCall = res;
        this.updateCurrentLicense();
      });
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
    });
  }

  getImage() {
    if (this.selectedCall.textDetected) {
      this.licenseService.getResult(this.selectedCall.id).subscribe((img) => {
        reader.readAsDataURL(img);
        reader.onload = (res) => {
          const urlImg = res.target.result.toString();
          this.img = this.sanitizer.bypassSecurityTrustUrl(urlImg);
        };
      });
    } else {
      this.licenseService.getSource(this.selectedCall.id).subscribe((img) => {
        reader.readAsDataURL(img);
        reader.onload = (res) => {
          const urlImg = res.target.result.toString();
          this.img = this.sanitizer.bypassSecurityTrustUrl(urlImg);
        };
      });
    }
  }
}
